import React from 'react';

export type BrandGlyphProps = {
  size?: number; // px
  title?: string;
  className?: string;
};

const BaseSvg: React.FC<React.PropsWithChildren<BrandGlyphProps>> = ({ size = 20, title, className, children }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    role="img"
    aria-label={title}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

// TikTok: stylized music note with slight offset echo (not used for social anymore; social uses lucide Music2)
export const TikTokGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <path
      d="M12 5v7.2A3.2 3.2 0 1 1 9.2 9.5V5h2.8Zm4 1.6c.5 1.8 2 3 4 3.4V12c-2-.2-3.6-1.1-4.8-2.5V6.6Z"
      fill="currentColor"
      stroke="none"
    />
  </BaseSvg>
);

// Boomplay: letter B in a circle
export const BoomplayGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9 7h4a2.5 2.5 0 0 1 0 5H9z" />
    <path d="M9 12h4a2.5 2.5 0 0 1 0 5H9z" />
  </BaseSvg>
);

// Deezer: stepped bars
export const DeezerGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <path d="M4 16h3M4 12h5M4 8h7M4 4h9" />
  </BaseSvg>
);

// Tidal: diamond grid
export const TidalGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <path d="M8 8l4-4 4 4-4 4z" />
    <path d="M4 12l4-4 4 4-4 4z" />
    <path d="M12 12l4-4 4 4-4 4z" />
  </BaseSvg>
);

// Audiomack: zigzag waveform
export const AudiomackGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <polyline points="3,15 6,12 9,16 12,10 15,14 18,9 21,12" />
  </BaseSvg>
);

// Spotify: three curved lines
export const SpotifyGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <path d="M4 15c5-2 11-1 14 1" />
    <path d="M5 12c4-1.5 9-1 12 .5" />
    <path d="M6 9c3-.8 6-.5 9 .5" />
  </BaseSvg>
);

// YouTube: play button inside rounded rectangle
export const YouTubeGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <rect x="3" y="7" width="18" height="10" rx="3" />
    <polygon points="11,10 15,12 11,14" />
  </BaseSvg>
);

// SoundCloud: cloud + bars
export const SoundCloudGlyph: React.FC<BrandGlyphProps> = (props) => (
  <BaseSvg {...props}>
    <path d="M7 16a4 4 0 1 1 5-5 3 3 0 0 1 4 5z" />
    <path d="M3 16v-2M5 16v-3M9 16v-4M11 16v-5" />
  </BaseSvg>
);
